import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IMyDpOptions } from 'mydatepicker';
import { NotificationsService } from "angular2-notifications";
import { Router, ActivatedRoute } from '@angular/router';
import { EncriptyUtilService } from '../../../../shared/services/encripty-util.service';
import { Location } from '@angular/common';
import * as moment from 'moment';
import { HttpParams } from '@angular/common/http';
import { DateUtilService } from '../../../../shared/services/date-util.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { VisualizarFuncionarioService } from './visualizar-funcionario.service';
import { NbFocusKeyManager } from '@nebular/theme/components/cdk/a11y/focus-key-manager';
import { EnderecoUtils } from '../../../../shared/utils/EnderecoUtils';

@Component({
  selector: 'ngx-visualizar-funcionario',
  templateUrl: './visualizar-funcionario.component.html',
  styleUrls: ['./visualizar-funcionario.component.scss'],
})

export class VisualizarFuncionarioComponent implements OnInit {


  public funcionarioId = null;
  public pessoaId = null;
  public pessoaCpf = null;
  public endereçoId = null;
  public isRegister = null;
  public listaTplogradouro = null;
  public listaEstado = null;
  public listCardTipoDoc = null;
  public listCardSexo = null;
  public listCardEstadoCivil = null;
  public formVisualizarFunc: FormGroup = null;
  public customLogin = null;
  public matricula = null;

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",
    //disableUntil: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() - 1 }
  };

  constructor(
    private notifications: NotificationsService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private encriptyService: EncriptyUtilService,
    private location: Location,
    private spinnerService: NgxSpinnerService,
    private service: VisualizarFuncionarioService,
    private dateUtilService: DateUtilService,
    private enderecoUtils: EnderecoUtils,
  ) {

    this.listCardTipoDoc = [

      {
        tipoDocumentoOficial: 'RG',
        descricao: 'RG'
      },
      {
        tipoDocumentoOficial: 'CNH',
        descricao: 'CNH'
      },
    ];

    this.listCardSexo = [

      {
        sexo: 'M',
        descricao: 'MASCULINO'
      },

      {
        sexo: 'F',
        descricao: 'FEMININO'
      },

    ];

    this.listCardEstadoCivil = [

      {
        estadoCivil: 'SOLTEIRO',
        descricao: 'SOLTEIRO'
      },
      {
        estadoCivil: 'CASADO',
        descricao: 'CASADO'
      },
      {
        estadoCivil: 'SEPARADO',
        descricao: 'SEPARADO'
      },
      {
        estadoCivil: 'DIVORCIADO',
        descricao: 'DIVORCIADO'
      },
      {
        estadoCivil: 'VIUVO',
        descricao: 'VIUVO'
      },
      {
        estadoCivil: 'UNIAO_ESTAVEL',
        descricao: 'UNIAO ESTAVEL'
      },

    ];

    this.listaTplogradouro = [

      {
        value: 'AVENIDA',
        descricao: 'Avenida'
      },

      {
        value: 'RUA',
        descricao: 'Rua'
      },

      {
        value: 'FAZENDA',
        descricao: 'Fazenda'
      },

      {
        value: 'LOTEAMENTO',
        descricao: 'Loteamento'
      },

      {
        value: 'RODOVIA',
        descricao: 'Rodovia'
      },

      {
        value: 'PRAÇA',
        descricao: 'Praça'
      },

      {
        value: 'OUTRO',
        descricao: 'Outro'
      }
    ]

    this.listaEstado = this.enderecoUtils.ufList;


    this.activatedRoute.queryParamMap.subscribe(params => {
      this.funcionarioId = this.encriptyService.decriptyBySecretKey(params.get('funcionarioId'));
      this.pessoaId = this.encriptyService.decriptyBySecretKey(params.get('pessoaId'));
      this.pessoaCpf = this.encriptyService.decriptyBySecretKey(params.get('pessoaCpf'));
      this.endereçoId = this.encriptyService.decriptyBySecretKey(params.get('endereçoId'));
      this.isRegister = this.encriptyService.decriptyBySecretKey(params.get('isRegister'));
      this.matricula = this.encriptyService.decriptyBySecretKey(params.get('matricula'));
    });

    this.formVisualizarFunc = this.formBuilder.group({
      id: [null],
      pessoaId: [null],
      status: [null],
      nome: [null],
      nomeMae: [null],
      nomePai: [null],
      matricula: [null],
      cpf: [null],
      statusCpf: [null],
      numeroDocumentoOficial: [null],
      tipoDocumentoOficial: [null],
      orgaoExpedidor: [null],
      nacionalidade: [null],
      naturalidade: [null],
      sexo: [null],
      estadoCivil: [null],
      dataAdmissao: [null],
      dataNascimento: [null],
      dataExpedicaoDocumento: [null],
      email: [null],
      cargo: [null],
      limiteInicial: [null],
      percentualLimite: [null],
      salarioBruto: [null],
      telefoneCelular: [null],
      cep: [null],
      estado: [null],
      localidade: [null],
      bairro: [null],
      complemento: [null],
      logradouro: [null],
      tipoLogradouro: [null],
      numero: [null],

    });


    if (this.funcionarioId != null) {

      this.buscaFuncionario(this.pessoaCpf, this.matricula);

    }

  }

  buscaFuncionario(cpf: string, matricula: string) {
    if (cpf != null && matricula != null) {
      this.spinnerService.show();
      this.service.pesquisaPessoaCpfMatricula(this.pessoaCpf, this.matricula, (response) => {
                this.buscaUsuario(response);
        this.spinnerService.hide();
      }, (error) => {
        this.spinnerService.hide();
        this.notifications.error('Não foi possível buscar informações do funcionario');
      });
    }
  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
  }

  buscaUsuario(data: any) {
      let pessoa: any = data.pessoa;

      if (pessoa != null) {

        this.formVisualizarFunc.controls['pessoaId'].setValue(pessoa.id);
        this.formVisualizarFunc.controls['nome'].setValue(pessoa.nome);
        this.formVisualizarFunc.controls['nomeMae'].setValue(pessoa.nomeMae);
        this.formVisualizarFunc.controls['nomePai'].setValue(pessoa.nomePai);
        this.formVisualizarFunc.controls['cpf'].setValue(pessoa.cpf);
        this.formVisualizarFunc.controls['statusCpf'].setValue(pessoa.statusCpf.value);
        this.formVisualizarFunc.controls['numeroDocumentoOficial'].setValue(pessoa.numeroDocumentoOficial);
        this.formVisualizarFunc.controls['tipoDocumentoOficial'].setValue(pessoa.tipoDocumentoOficial);
        this.formVisualizarFunc.controls['orgaoExpedidor'].setValue(pessoa.orgaoExpedidor);
        this.formVisualizarFunc.controls['nacionalidade'].setValue(pessoa.nacionalidade);
        this.formVisualizarFunc.controls['naturalidade'].setValue(pessoa.naturalidade);
        this.formVisualizarFunc.controls['sexo'].setValue(pessoa.sexo);
        this.formVisualizarFunc.controls['estadoCivil'].setValue(pessoa.estadoCivil);

        if (pessoa.dataNascimento != null) {
          let dataNascimento = moment(pessoa.dataNascimento).format('DD/MM/YYYY')
          this.formVisualizarFunc.controls['dataNascimento'].setValue(dataNascimento);
        }

        if (pessoa.dataExpedicaoDocumento != null){
          let dataExpedicaoDocumento = moment(pessoa.dataExpedicaoDocumento).format('DD/MM/YYYY')
          this.formVisualizarFunc.controls['dataExpedicaoDocumento'].setValue(dataExpedicaoDocumento);
        }

        this.formVisualizarFunc.controls['email'].setValue(pessoa.email);
        this.formVisualizarFunc.controls['telefoneCelular'].setValue(pessoa.telefoneCelular);


      }

      let endereco: any = data.endereco;

      if (endereco != null) {
        this.formVisualizarFunc.controls['cep'].setValue(endereco.cep);
        this.formVisualizarFunc.controls['estado'].setValue(endereco.estado);
        this.formVisualizarFunc.controls['localidade'].setValue(endereco.localidade);
        this.formVisualizarFunc.controls['logradouro'].setValue(endereco.logradouro);
        this.formVisualizarFunc.controls['bairro'].setValue(endereco.bairro);
        this.formVisualizarFunc.controls['complemento'].setValue(endereco.complemento);
        this.listaTplogradouro.forEach(tipo => {
           if (tipo.value === endereco.tipoLogradouro) {
            this.formVisualizarFunc.controls['tipoLogradouro'].setValue(tipo.value);
          }
        });
        this.formVisualizarFunc.controls['numero'].setValue(endereco.numero);
      }

      let funcionario: any = data.funcionario;
      this.formVisualizarFunc.controls['id'].setValue(funcionario.id);
      this.formVisualizarFunc.controls['matricula'].setValue(funcionario.matricula);
      this.formVisualizarFunc.controls['cargo'].setValue(funcionario.cargo);
      this.formVisualizarFunc.controls['status'].setValue(funcionario.status);
      if (funcionario.dataAdmissao != null) {
        let dataAdmissao = moment(funcionario.dataAdmissao).format('DD/MM/YYYY')

        this.formVisualizarFunc.controls['dataAdmissao'].setValue(dataAdmissao);

      }

  }

  fecharForm() {

    this.location.back();

  }

  buscaEndereco(data) {

    if (data.cep === null) {
      this.notifications.error('CEP não existe!!!');
    } else {

      let tipoLogradouro = data.logradouro.split(" ")[0];
      let logradouro = data.logradouro.split(tipoLogradouro + " ")[1];

      this.formVisualizarFunc.controls['cep'].setValue(data.cep);
      this.formVisualizarFunc.controls['estado'].setValue(data.estado);
      this.formVisualizarFunc.controls['logradouro'].setValue(logradouro);
      this.formVisualizarFunc.controls['tipoLogradouro'].setValue(tipoLogradouro);
      this.formVisualizarFunc.controls['complemento'].setValue(data.complemento);
      this.formVisualizarFunc.controls['localidade'].setValue(data.localidade);
      this.formVisualizarFunc.controls['estado'].setValue(data.uf);
      this.formVisualizarFunc.controls['bairro'].setValue(data.bairro);


    }
  }

  formateDateSaveBD(data) {
    return new Date(data).getTime();
  }

  previousPage() {
    this.location.back();
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }
}
